import { render } from "./Footer.vue?vue&type=template&id=f517a074&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=f517a074&scoped=true&lang=less"

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f517a074"]])

export default __exports__